module.exports = __webpack_public_path__ + "static/podnosnik-koszowy-rzeszow-76b8110b29a0ffbccde640f6af3540b8.jpg";